<template>
	<v-dialog width="600px" persistent v-model="showDialog">
		<v-card>
			<v-card-title class="create-form-heading"
				>Add Acknowledgement</v-card-title
			>
			<v-card-text>
				<v-flex xs12>
					<v-text-field
						v-model="acknowledgementForm.name"
						label="Name"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						v-model="acknowledgementForm.dstrPhone"
						label="Distributor Phone No"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						v-model="acknowledgementForm.bank"
						label="Bank"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						v-model="acknowledgementForm.ifscCode"
						label="IFSC Code"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						v-model="acknowledgementForm.transferDate"
						type="date"
						label="Date"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						v-model="acknowledgementForm.amount"
						min="0"
						type="number"
						label="Amount"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						v-model="acknowledgementForm.txnId"
						label="Reference No"
					></v-text-field>
				</v-flex>
				<v-layout>
					<v-flex xs9>
						<v-text-field
							v-model="acknowledgementForm.otp"
							label="OTP"
						></v-text-field>
					</v-flex>
					<v-btn
						xs3
						:disabled="isOtpDisabled()"
						:loading="otpLoading"
						:color="themeInputColor"
						class="white--text"
						@click="sendOtp()"
						>Send OTP</v-btn
					>
				</v-layout>
			</v-card-text>
			<v-layout row wrap class="justify-space-between px-2 pb-2">
				<v-btn
					:disabled="isFormDisabled()"
					:loading="sendingAcknowledgement"
					:color="themeInputColor"
					class="white--text"
					@click="saveDetails()"
					>Save</v-btn
				>
				<v-btn @click="closeModal">Close</v-btn>
			</v-layout>
		</v-card>
	</v-dialog>
</template>
<script>
import {
	JEET11_PAYMENT_SEND_OTP,
	ADD_FINANCE_ACKNOWLEDGEMENTS
} from "@/store/action-types";
import { _checkDecimalFormat } from "@/utils";
export default {
	name: "addAcknowledgement",
	props: ["model", "themeInputColor"],
	data() {
		return {
			showDialog: true,
			acknowledgementForm: {
				name: "",
				bank: "",
				ifscCode: "",
				transferDate: "",
				amount: "",
				txnId: "",
				otp: "",
				dstrPhone: ""
			},
			otpLoading: false,
			sendingAcknowledgement: false
		};
	},
	methods: {
		sendOtp() {
			if (!this.otpLoading) {
				this.otpLoading = true;
				let payload = {
					phone: this.acknowledgementForm.dstrPhone,
					amount: this.acknowledgementForm.amount,
					countryAreaCode: "91",
					url: "jeet11-finance"
				};
				this.$store
					.dispatch(JEET11_PAYMENT_SEND_OTP.dispatch, payload)
					.catch(() => {})
					.then(() => {
						this.otpLoading = false;
					});
			}
		},
		saveDetails() {
			if (!this.sendingAcknowledgement) {
				this.sendingAcknowledgement = true;
				let payload = {
					...this.acknowledgementForm,
					action: "approve",
					transferDate: new Date(
						this.acknowledgementForm.transferDate
					).getTime(),
					dstrPhone: "91" + this.acknowledgementForm.dstrPhone,
					amount: Number(this.acknowledgementForm.amount)
				};
				this.$store
					.dispatch(ADD_FINANCE_ACKNOWLEDGEMENTS.dispatch, payload)
					.catch(() => {})
					.then(data => {
						this.sendingAcknowledgement = false;
						if (data.statusCode == 200) {
							this.closeModal();
						}
					});
			}
		},
		closeModal() {
			this.$emit("CLOSE_MODAL", this.model);
		},
		isOtpDisabled() {
			return (
				!this.acknowledgementForm.name ||
				!this.acknowledgementForm.bank ||
				!this.acknowledgementForm.dstrPhone ||
				(this.acknowledgementForm.dstrPhone &&
					(/\D/g.test(this.acknowledgementForm.dstrPhone) ||
						this.acknowledgementForm.dstrPhone.length !== 10)) ||
				!this.acknowledgementForm.ifscCode ||
				!this.acknowledgementForm.transferDate ||
				!this.acknowledgementForm.amount ||
				(this.acknowledgementForm.amount &&
					!_checkDecimalFormat(this.acknowledgementForm.amount)) ||
				!this.acknowledgementForm.txnId
			);
		},
		isFormDisabled() {
			return (
				!this.acknowledgementForm.name ||
				!this.acknowledgementForm.bank ||
				!this.acknowledgementForm.dstrPhone ||
				(this.acknowledgementForm.dstrPhone &&
					(/\D/g.test(this.acknowledgementForm.dstrPhone) ||
						this.acknowledgementForm.dstrPhone.length !== 10)) ||
				!this.acknowledgementForm.ifscCode ||
				!this.acknowledgementForm.transferDate ||
				!this.acknowledgementForm.amount ||
				(this.acknowledgementForm.amount &&
					!_checkDecimalFormat(this.acknowledgementForm.amount)) ||
				!this.acknowledgementForm.txnId ||
				!this.acknowledgementForm.otp ||
				(this.acknowledgementForm.otp &&
					this.acknowledgementForm.otp.length !== 6)
			);
		}
	}
};
</script>
